'use client';

import React from 'react';

import Grid from '@mui/material/Grid';
import styled from 'styled-components';

const Content = styled.main<{ $rowReverse?: boolean }>`
  ${({ $rowReverse }) => ($rowReverse ? `margin-left: auto;` : `margin-lefright: auto;`)}
  max-width: 730px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-left: 0;
    margin-right: 0;
    max-width: none;
  }
`;

const Aside = styled.aside`
  position: sticky;
  top: 50px;
`;

interface TwoColumnLayoutProps {
  children: [React.ReactNode, React.ReactNode];
  rowReverse?: boolean;
  sx?: object;
}

/**
 * layout with two columns
 * @prop children of length 2
 */
const TwoColumnLayout = ({ children, rowReverse, sx }: TwoColumnLayoutProps) => {
  return (
    <Grid container spacing={2} justifyContent="space-between" direction={rowReverse ? 'row-reverse' : 'row'} sx={sx}>
      <Grid item xs={12} md={8}>
        <Content $rowReverse={rowReverse}>{children[0]}</Content>
      </Grid>
      <Grid item md={4} sx={{ display: { xs: 'none', md: 'block' } }}>
        <Aside>{children[1]}</Aside>
      </Grid>
    </Grid>
  );
};

export default TwoColumnLayout;
